import { navItems } from "@/mocks/siteContent";

export default function Hero() {
  const go = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20cinematic%20abstract%20depiction%20of%20a%20quiet%20suburban%20neighborhood%20street%20at%20dusk%20with%20glowing%20amber%20windows%2C%20soft%20hazy%20atmosphere%2C%20muted%20terracotta%20cream%20and%20deep%20brown%20tones%2C%20painterly%20artistic%20style%2C%20moody%20dramatic%20low%20light%2C%20no%20text%2C%20shallow%20depth%20of%20field%2C%20editorial%20poster%20aesthetic&width=1920&height=1080&seq=nw-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/35 to-foreground-950/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <div className="max-w-4xl flex flex-col items-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm mb-6 backdrop-blur-sm">
            <i className="ri-sparkling-2-line" aria-hidden="true"></i>
            短剧 · 小说 · 电影 · 未删减 · 类似推荐
          </span>

          <h1 className="font-heading text-background-50 text-3xl md:text-5xl lg:text-6xl font-black leading-tight">
            邻居的妻子
            <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl">
              一套题材，各版本剧情一次看全
            </span>
          </h1>

          <p className="mt-6 text-background-100/90 text-sm md:text-base leading-relaxed max-w-2xl">
            把以「邻居的妻子」为母题的短剧、小说与电影集中整理在一起，按载体与口味讲清各版本的剧情走向、看点差异与未删减方向。刚入坑不知道从哪部开始？往下看就有答案。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button
              type="button"
              onClick={() => go("drama")}
              className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors flex items-center justify-center gap-2"
            >
              <i className="ri-play-list-2-line" aria-hidden="true"></i>
              先看短剧盘点
            </button>
            <button
              type="button"
              onClick={() => go("recommend")}
              className="w-full sm:w-auto px-7 py-3 rounded-md bg-background-50/12 border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors flex items-center justify-center gap-2 backdrop-blur-sm"
            >
              <i className="ri-filter-3-line" aria-hidden="true"></i>
              按口味找类似推荐
            </button>
          </div>

          <div className="mt-10 hidden md:flex flex-wrap items-center justify-center gap-2">
            {navItems.slice(0, 6).map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => go(item.id)}
                className="px-3.5 py-1.5 rounded-full text-xs text-background-100 border border-background-50/25 bg-background-50/10 whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}